import Row from "@Containers/components/Row";
import {ReactNode} from "react";

export type PillType = {
    id: string,
    label: string | ReactNode,
    onClick: () => void,
    isActive: boolean,
}

interface PillsProps {
    pills: PillType[],
    wrapperClassName?: string,
    tabClassName?: string,
    activeTabClassName?: string,
}

/**
 * Pills component contains pill buttons which can be used for navigation.
 */
const Pills = (props: PillsProps) => {
    const {
        pills,
        wrapperClassName = "gb--pill-container",
        tabClassName = "gb--pill",
        activeTabClassName = "gb--pill__active",
    } = props

    return (
        <Row className={wrapperClassName}>
            {pills.map(({isActive, onClick, label, id}) => (
                <button
                    type="button"
                    className={`${tabClassName} ${isActive ? activeTabClassName : ""}`}
                    onClick={onClick}
                    key={id}
                >
                    {label}
                </button>
            ))}
        </Row>
    );
};

export default Pills;